import { Alert, Button } from 'antd';
import { Link } from 'react-router';
import { mapDevicePath } from '../gps.paths';
import { useUnmappedDevices } from '../hooks/use-unmapped-devices';

const formatInstant = (instant: string) => new Date(instant).toLocaleString(undefined, { dateStyle: 'medium', timeStyle: 'short' });

/** Devices reporting with no truck: their positions are kept but shown on nothing until each is put on a truck. Nothing renders when there are none. */
export function UnmappedDevicesPanel({ integrationId }: { integrationId: string }) {
  const state = useUnmappedDevices(integrationId);
  if (state.status !== 'loaded' || state.total === 0) return null;

  const more = state.total - state.devices.length;
  return (
    <Alert
      type="warning"
      showIcon
      title={`${state.total} ${state.total === 1 ? 'device is' : 'devices are'} reporting with no truck`}
      description={
        <div className="flex flex-col gap-3">
          <p>Their positions are kept, but show on no truck until you say which truck each is on.</p>
          <ul className="divide-y divide-line rounded-lg border border-line bg-surface">
            {state.devices.map((device) => (
              <li key={device.deviceId} className="flex flex-wrap items-center justify-between gap-2 px-3 py-2">
                <div className="min-w-0">
                  <code className="text-fg">{device.deviceId}</code>
                  <p className="text-xs text-muted">
                    Last heard {formatInstant(device.lastSeenAt)} · {device.eventCount} {device.eventCount === 1 ? 'report' : 'reports'}
                  </p>
                </div>
                <Link to={mapDevicePath(integrationId, device.deviceId)}>
                  <Button size="small" type="primary">
                    Put on a truck
                  </Button>
                </Link>
              </li>
            ))}
          </ul>
          {more > 0 && <p className="text-xs text-muted">And {more} more. Map these first and the next ones show here.</p>}
        </div>
      }
    />
  );
}
